import { RequestFeature } from '../components/Settings/RequestFeature/RequestFeature'

export const RequestFeaturePage = () => {
    return <RequestFeature />
}
